module.exports = __webpack_public_path__ + "img/mine.d8fde12a.svg";